// extracted by mini-css-extract-plugin
export default {"spinner-content":"ClaimDepartment_spinner-content__vNlfd","spinner":"ClaimDepartment_spinner__A4uof"};